/** Personality → signature doodle component map.
 *  Used to add storytelling doodles around personality cards & PDPs. */
import {
  Frog, MusicNote, Trumpet, Bird, Butterfly, Flower, Spiral,
  Lightning, Ice, Crayon, Heart, Scribble,
} from "./Doodles";
import { SunDoodle, Cloud, Star, PaperPlane } from "./Illustrations";

/** Two doodles per personality — primary + secondary, plus default tints. */
export const PERSONALITY_DOODLES = {
  "sunshine-chasers": {
    primary: SunDoodle,
    secondary: Flower,
    primaryProps: { size: 64, color: "#F4C734", className: "spin-slow" },
    secondaryProps: { size: 44, color: "#DD2E20", center: "#F4C734", className: "wiggle" },
  },
  "non-stop-runners": {
    primary: Lightning,
    secondary: Star,
    primaryProps: { size: 54, color: "#DD2E20", className: "wiggle" },
    secondaryProps: { size: 22, color: "#2C2C2A", className: "wiggle" },
  },
  "tiny-trendsetters": {
    primary: Crayon,
    secondary: Flower,
    primaryProps: { size: 80, color: "#F4C734", className: "float-med" },
    secondaryProps: { size: 44, color: "#F0A8C3", center: "#DD2E20", className: "wiggle" },
  },
  "dreamy-wanderers": {
    primary: Cloud,
    secondary: Star,
    primaryProps: { size: 90, color: "#FAFAF7", className: "float-slow opacity-80" },
    secondaryProps: { size: 20, color: "#F4C734", className: "wiggle" },
  },
  "fearless-tryers": {
    primary: PaperPlane,
    secondary: Spiral,
    primaryProps: { size: 50, color: "#2C2C2A", className: "float-med" },
    secondaryProps: { size: 40, color: "#8BC547", className: "wiggle" },
  },
  "high-energy-kids": {
    primary: Trumpet,
    secondary: MusicNote,
    primaryProps: { size: 70, color: "#F4C734", className: "wiggle" },
    secondaryProps: { size: 40, color: "#FAFAF7", className: "float-med" },
  },
  "friendly-explorers": {
    primary: Frog,
    secondary: Heart,
    primaryProps: { size: 60, color: "#8BC547", className: "wiggle" },
    secondaryProps: { size: 28, color: "#DD2E20", className: "wiggle" },
  },
};

/** Render the primary doodle of a personality, with extra className overrides. */
export function PrimaryDoodle({ personality, className = "", style }) {
  const d = PERSONALITY_DOODLES[personality];
  if (!d) return null;
  const Comp = d.primary;
  return <Comp {...d.primaryProps} className={`${d.primaryProps.className || ""} ${className}`} style={style} />;
}

export function SecondaryDoodle({ personality, className = "", style }) {
  const d = PERSONALITY_DOODLES[personality];
  if (!d) return null;
  const Comp = d.secondary;
  return <Comp {...d.secondaryProps} className={`${d.secondaryProps.className || ""} ${className}`} style={style} />;
}
